import {WPApi} from "../common/wp-api";

const wp = new WPApi();
import {isMobile} from "../common/utils";


jQuery(document).ready(async ($) => {
    let showsContainer = $('.all-channels-container');


    $(document).on('click', '.channel-name-wrapper img', function () {
        let channel = $(this).attr('alt');

        sport1Analytics.sendEvent('tv-schedule', 'channels-logo-click', channel);
    })

    $(document).on('click', '.show-container', function () {
        let title = $('.show-name', this).text().trim();

        sport1Analytics.sendEvent('tv-schedule', 'game-click', title);
    })


    $('.day-wrapper-link').click(async function (element) {
        let day = $(this).text().trim();
        sport1Analytics.sendEvent('tv-schedule', 'day-click', day);

        if (!$(this).parent().hasClass('selected')) {
            $('.day-wrapper.selected').removeClass('selected');
            $(this).parent().addClass('selected');
            let daySelected = element.currentTarget.id;
            let urlRequest = '';
            
            const urlParams = new URLSearchParams(window.location.search);
            const currentChannelId = urlParams.get('channel_id');

            if (currentChannelId) {
                urlRequest = 'sport1/v1/broadcast/day/' + daySelected + '/channel/' + currentChannelId;
                window.history.pushState('', '', '?day_selected=' + daySelected + '&channel_id=' + currentChannelId);
            } else {
                urlRequest = 'sport1/v1/broadcast/day/' + daySelected + '/?live=1';
                window.history.pushState('', '', '?day_selected=' + daySelected + '&live=1');
            }

            let shows = await wp.get(urlRequest);
            if (shows) {
                showsContainer.hide();
                showsContainer.html('');
                showsContainer.append(shows);
                showsContainer.fadeIn();
            }
        }
    });

    $('.channel-wrapper-link').click(async function () {
        let channelSelected = this.id;

        let channel = $(this).text().trim();
        let analyticsAction;


        if (channelSelected === 'all') {
            analyticsAction = 'all-channels-click';
        } else {
            analyticsAction = 'channel-click';
        }

        sport1Analytics.sendEvent('tv-schedule', analyticsAction, channel);

        if (!$(this).children(0).hasClass('selected')) {


            if (isMobile()) {
                orderChannelsInCollapseElement(this);
            } else {
                $('.channel-wrapper.selected').removeClass('selected');
                $(this).children(0).addClass('selected');
            }

            let urlRequest = '';
            let daySelected = $('.day-wrapper.selected').attr('data-date');
            if (channelSelected !== 'all') {
                urlRequest = 'sport1/v1/broadcast/day/' + daySelected + '/channel/' + channelSelected;
                window.history.pushState('', '', '?day_selected=' + daySelected + '&channel_id=' + channelSelected);
            } else {
                urlRequest = 'sport1/v1/broadcast/day/' + daySelected + '/?live=1';
                window.history.pushState('', '', '?day_selected=' + daySelected + '&live=1');
            }
            let shows = await wp.get(urlRequest);
            if (shows) {
                showsContainer.hide();
                showsContainer.html('');
                showsContainer.append(shows);
                showsContainer.fadeIn();

                const $banners = $('.ad', showsContainer);

                const slots = $banners.map(function () {
                    return window[$(this).attr('id')];
                }).toArray();

                googletag.cmd.push(function () {
                    googletag.pubads().refresh(slots);
                });
            }
        }
    });

    $('.btn-primary').click(function () {
        let image = $('#channels-image-arrow-down');
        if (image.hasClass('selected')) {
            image.removeClass('selected');
        } else {
            image.addClass('selected');
        }
    });

});

function orderChannelsInCollapseElement(element) {
    let collapseOpenerButtonText = $('.btn-primary-text');
    let collapseOpenerButtonElement = $('.btn-primary');
    let channelSelectedTextElement = $('.channel-wrapper-title', element);

    let previousChannelName = collapseOpenerButtonText.text();
    let previousChannelId = collapseOpenerButtonElement.attr('id');
    let channelName = channelSelectedTextElement.text();
    let channelSelected = element.id;

    let selectedOrder = channelSelected;
    let previousOrder = previousChannelId;
    if (previousChannelId === 'all') {
        previousOrder = 0;
    }
    if (channelSelected === 'all') {
        selectedOrder = 0;
    }

    collapseOpenerButtonText.text(channelName);
    collapseOpenerButtonElement.attr('id', element.id);
    element.id = previousChannelId;
    element.classList.remove('order-' + channelSelected);
    element.classList.add('order-' + previousChannelId);
    channelSelectedTextElement.text(previousChannelName);
}
